import React from 'react';
import { Input, AffiliationRecapMolecule, AffiliationButtonMolecule } from '../../Molecules';
import { Text, ProgressBar, Checkbox, DatePicker, Icon, Button } from '../../Atoms';
import { Row, Col } from 'react-bootstrap';

function OrganismAffiliationStage4(props) {
    const renderRemboursement = () => {
        return (<Row className="organism-affiliation-stage1-row" >
            <Col lg={3} xs={12} sm={12} className="organism-affiliation-stage1-col">
                <Input
                    placeholder="Nom et prénom"
                    inputLabel="Propriétaire du compte"
                    labelClassName="organism-affiliation-stage1-input-label"
                    classNameInputContainer="organism-affiliation-stage1-input-container"

                />
            </Col>
            <Col lg={5} xs={12} sm={12} className="organism-affiliation-stage1-col" >
                <Input
                    placeholder="IBAN"
                    inputLabel="IBAN"
                    labelClassName="organism-affiliation-stage1-input-label"
                    classNameInputContainer="organism-affiliation-stage1-input-container"

                />
            </Col>
            <Col lg={3} xs={12} sm={12} className="organism-affiliation-stage1-col">
                <Input
                    placeholder="BIC"
                    inputLabel="BIC"
                    labelClassName="organism-affiliation-stage1-input-label"
                    classNameInputContainer="organism-affiliation-stage1-input-container"
                />
            </Col>
        </Row>)
    }
    return (
        <div className="organism-affilation-stage1-container">
            <Text text="Complétez votre affiliation" className="organism-affiliation-stage1-title" />
            <Text text="Afin de finaliser votre adhésion, merci de bien vouloir remplir les champs suivants :" className="organism-affiliation-stage1-description" />
            <Text text={`Etape ${props.stage} / 5`} className="organism-affiliation-stage1-stage" />
            <ProgressBar
                percent={`${(props.stage * 100 / 5).toString()}%`}
                height="15px"
                backgroundColor="#fff"
                backgroundColorFulFilled="#FF8AD8"
                containerClassName="organism-affiliation-stage1-progressBar"
            />
            <div >
                <div className="organism-affiliation-stage1-recap-container">
                    <AffiliationRecapMolecule />
                </div>
                <div className="organism-affiliation-form-container">
                    <Text text="Ayants-droit" className="organism-affiliation-stage1-personal-info" />
                    <div className="organism-affiliation-stage2-description">Vous pouvez <span>ajouter des bénéficiaires</span> à votre contrat.</div>
                    <Text text="Cette étape est facultative, si vous ne souhaitez pas ajouter un bénéficiaire, veuillez passer à l’étape suivante." className="organism-affiliation-stage1-input-label full-container" />
                    <Row className="organism-affiliation-stage1-row" >
                        <Col lg={2} xs={12} className="organism-affiliation-stage1-col">
                            <Text text="Civilité" className="organism-affiliation-stage1-input-label" />
                            <div className="organism-affiliation-stage1-checkBox-container" >
                                <Checkbox
                                    type="checkbox"
                                    label="Mme"
                                    className="organism-affiliation-stage1-checkbox"
                                    classNameContainer="organism-affiliation-checkbox-container"
                                    size={13}
                                    onClick={(e) => props.checkBoxAyantDroitClicked(e.target.textContent)}
                                    checked={props.ayantDroitData.check == 'Mme'}
                                />
                                <Checkbox
                                    type="checkbox"
                                    label="M"
                                    className="organism-affiliation-stage1-checkbox"
                                    classNameContainer="organism-affiliation-checkbox-container"
                                    size={13}
                                    onClick={(e) => props.checkBoxAyantDroitClicked(e.target.textContent)}
                                    checked={props.ayantDroitData.check == 'M'}
                                />
                            </div>

                        </Col>
                        <Col lg={3} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Input
                                placeholder=""
                                inputLabel="Type de bénéficiaire"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                optionsClassName="organism-affiliation-stage1-input-label organism-affiliation-stage1-option-input"
                                as="select"
                                options={[
                                    {
                                        text: "Célibataire",
                                        value: "Célibataire"
                                    },
                                    {
                                        text: "Marié(e)",
                                        value: "Marié(e)"
                                    },
                                ]}
                                onChange={(e) => props.inputAyantDroitChange(e, 'beneficiaryType')}
                                value={props.ayantDroitData.beneficiaryType}
                                optionContainerClassName="organism-affiliation-stage1-option-selected"
                            />
                        </Col>
                        <Col lg={4} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Input
                                placeholder=""
                                inputLabel="Nom"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputAyantDroitChange(e.target.value, 'firstName')}
                                value={props.ayantDroitData.firstName}
                            />
                        </Col>
                        <Col lg={3} xs={6} sm={6} className="organism-affiliation-stage1-col">
                            <Input
                                placeholder=""
                                inputLabel="Prénom"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputAyantDroitChange(e.target.value, 'lastName')}
                                value={props.ayantDroitData.lastName}
                            />
                        </Col>
                        <Col lg={3} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Text text="Date de naissance" className="organism-affiliation-stage1-input-label" />
                            <DatePicker
                                placeholder="JJ/MM/AAAA"
                                renderIcon={false}
                                containerClassName="organism-affiliation-stage1-input-container"
                                className="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputAyantDroitChange(e, 'date')}
                                selected={props.ayantDroitData.date}
                            />
                        </Col>
                        <Col lg={4} xs={6} sm={6} className="organism-affiliation-stage1-col">
                            <Input
                                placeholder=""
                                inputLabel="Numéro de sécurité sociale"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputAyantDroitChange(e.target.value, 'securityNumber')}
                                value={props.ayantDroitData.securityNumber}
                            />
                        </Col>
                        <Col lg={3} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Input
                                placeholder=""
                                inputLabel="Organisme de rattachement"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputAyantDroitChange(e.target.value, 'rattachement')}
                                value={props.ayantDroitData.rattachement}
                            />
                        </Col>
                        {props.showLazerNAC() && <Col lg={2} xs={3} sm={3} className="organism-affiliation-stage1-col" >
                            <div style={{ display: "flex", alignItems: "center", width: "max-content" }}>
                                <Text text="Rang laser" className="organism-affiliation-stage1-input-label" />
                                <Icon icon="QuestionMark" size="13px" style={{ marginLeft: "13px" }} />
                            </div>
                            <Input
                                placeholder=""
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputAyantDroitChange(e.target.value, 'laserRank')}
                                value={props.ayantDroitData.laserRank}
                            />
                        </Col>}
                    </Row>
                    {props.showLazerNAC() && <div style={{ display: "flex", alignItems: "center", width: "max-content" }}>
                        <Checkbox
                            label="Enfant NAC"
                            classNameContainer="organism-affiliation-stage4-checkbox-container"
                            className="organism-affiliation-stage4-checkbox"
                            size={13}
                            onClick={(e) => props.inputAyantDroitChange(!props.ayantDroitData.childNAC, 'childNAC')}
                            checked={props.ayantDroitData.childNAC}
                        />
                        <Icon icon="QuestionMark" size="13px" style={{ marginLeft: "13px" }} />
                    </div>}
                    <Text text="Informations de remboursements :" className="organism-affiliation-stage1-remboursement" />
                    <div className="organism-affiliation-stage1-checkBox-container organism-affiliation-stage4-checkBox-container" >
                        <Checkbox
                            type="checkbox"
                            label="Utiliser le même compte que Alba LESIRE"
                            className="organism-affiliation-stage1-checkbox"
                            classNameContainer="organism-affiliation-checkbox-container"
                            size={13}
                            onClick={(e) => props.checkBoxAyantDroitRemboursementClicked(e.target.textContent)}
                            checked={props.checkBoxAyantDroitRemboursement == 'Utiliser le même compte que Alba LESIRE'}
                        />
                        <Checkbox
                            type="checkbox"
                            label="Ajouter un compte"
                            className="organism-affiliation-stage1-checkbox"
                            classNameContainer="organism-affiliation-checkbox-container"
                            size={13}
                            onClick={(e) => props.checkBoxAyantDroitRemboursementClicked(e.target.textContent)}
                            checked={props.checkBoxAyantDroitRemboursement == 'Ajouter un compte'}
                        />
                    </div>
                    {props.checkBoxAyantDroitRemboursement == 'Ajouter un compte' && renderRemboursement()}
                    <Button text="Ajouter un ayant-droit supplémentaire" className="organism-affiliation-stage4-button" />
                </div>
            </div>
            <AffiliationButtonMolecule
                confirmerClicked={props.confirmerClicked}
                goBackClicked={props.goBackClicked}
            />
        </div>
    );
}

export default OrganismAffiliationStage4;
